import React from "react";
import Buttons from "../../../../../../base/basicComponents/button";
import {
  ProposedChangeTagDiv,
  UpdateSupportingSectionStatusDiv,
} from "../../../../../../base/basicComponents/status";
import UploadFile from "../../../../../../base/basicComponents/uploadFile";
import { dataStatus, fileTags, proposedChangeTags } from "../../../../../publicDictionaryValues";
import ReviseProcedureFileTbody from "../../../../procedureFileSections/fields/procedureFileTbodyFields/reviseProcedureFileTbody";
import "../index.scss";

export default class ReviseUpdateSupportingFileTbody extends ReviseProcedureFileTbody {
  constructor(props: any) {
    super(props);
    this.state = {
      inputRef: "",
    };
    // @ts-ignore
    this.isShowReplaceBtn = false;
    // @ts-ignore
    this.isShowDeleteBtn = false;
    // @ts-ignore
    this.isShowCancelBtn = false;
  }

  /**
   * function about control the  return to draft and approve buttons show in approve page
   * @param {*} row
   */
  judgeIsShowReplaceAndDeleteBtn = (row: any) => {
    const proposedChangeTag = row.data.find((item: any) => item.name === "proposedChange").value;
    const status = row.data.find((x: any) => x.name === "status").value;
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;
    const preFileTag = row.data.find((item: any) => item.name === "previousFileTag").value;
    const isReviewed = row.data.find((item: any) => item.name === "isReviewed").value;
    // @ts-ignore
    this.isShowReplaceBtn =
      status === dataStatus.return &&
      ((proposedChangeTag === proposedChangeTags.new && preFileTag !== fileTags.deleted) ||
        (proposedChangeTag === proposedChangeTags.new &&
          preFileTag === fileTags.deleted &&
          isReviewed) ||
        proposedChangeTag === proposedChangeTags.update);

    // @ts-ignore
    this.isShowDeleteBtn =
      status !== dataStatus.approval &&
      ((proposedChangeTag === proposedChangeTags.new && preFileTag !== fileTags.deleted) ||
        proposedChangeTag === proposedChangeTags.delete ||
        (tagValue === fileTags.new && proposedChangeTag === null) ||
        (proposedChangeTag === proposedChangeTags.new &&
          preFileTag === fileTags.deleted &&
          isReviewed));

    // @ts-ignore
    this.isShowCancelBtn =
      proposedChangeTag === proposedChangeTags.delete && status !== dataStatus.approval;
  };

  /**
   * function about show tag if column type is tag
   * @param {*} column
   * @param {*} rowColumn
   * @param {*} tagValue
   * @returns
   */
  returnTag = (column: any, rowColumn: any, tagValue: any) => {
    return column.dataName === "status" ? (
      <>
        <UpdateSupportingSectionStatusDiv status={rowColumn.value} tagValue={tagValue} />
      </>
    ) : (
      <>
        <ProposedChangeTagDiv status={rowColumn.value} />
      </>
    );
  };

  /**
   * function about show button if column type is button
   * @param {*} row
   * @param {*} column
   * @param {*} rowIndex
   * @param {*} status
   * @returns
   */
  returnButton = (row: any, column: any, rowIndex: any, status: any) => {
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;
    const isReviewed = row.data.find((item: any) => item.name === "isReviewed").value;

    return (
      <div className="buttonTd-content">
        {/* @ts-ignore */}
        {this.isShowReplaceBtn && (
          <>
            <Buttons
              color={column.approveColor}
              size="small"
              onClick={(e: any) => column.onApproveClick(e)}
              disabled={row.isApproveDisabled}
              rowindex={rowIndex}
              testid={`revise-supporting-file-approve-btn-${rowIndex}`}
            >
              {column.approveText}
            </Buttons>
            <UploadFile
              fileInputRef={row.replaceRef}
              isMultiple={false}
              handleFileSelect={this.props.handleFileSelect}
              rowindex={rowIndex}
              isSupportingFile={false}
            />
          </>
        )}
        {/* @ts-ignore */}
        {this.isShowDeleteBtn && (
          <Buttons
            color={column.returnColor}
            size="small"
            onClick={column.onReturnClick(rowIndex)}
            disabled={tagValue === fileTags.deleted && isReviewed}
            rowindex={rowIndex}
            testid={`revise-supporting-file-return-btn-${rowIndex}`}
          >
            {column.returnText}
          </Buttons>
        )}
        {/* @ts-ignore */}
        {this.isShowCancelBtn && (
          <Buttons
            color={column.approveColor}
            size="small"
            onClick={column.onCancelClick(rowIndex)}
            disabled={tagValue === fileTags.cancelled && isReviewed}
            rowindex={rowIndex}
            testid={`revise-supporting-file-cancel-btn-${rowIndex}`}
          >
            {column.cancelText}
          </Buttons>
        )}
      </div>
    );
  };
}
